import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useModuleIds, useUserProjectRole } from 'portal/lib/hooks'
import { metersLoad } from 'portal/store/utilities/meters/actions'

export const useMetersLoader = () => {
  const dispatch = useDispatch()
  const { accountId, projectId } = useModuleIds()

  const { isReadOnly } = useUserProjectRole(accountId, projectId)

  const reload = useCallback(() => {
    if (!accountId || !projectId) {
      return
    }
    dispatch(metersLoad(accountId, projectId))
  }, [dispatch, accountId, projectId])

  useEffect(() => {
    reload()
  }, [reload])

  const { loading, error, items } = useSelector((state: any) => {
    return state.meters
  })

  return {
    loading,
    error,
    items,
    reload,
    readOnly: isReadOnly
  }
}
